jQuery(document).ready(function ($) {
  //################################################################//
  //######*****   Saved Basket drawer
  //################################################################//

  $(".penketh-saved-basket-eye").click(function () {
    // Cancel other parents
    $("tr.wsc_cart-tr-body").removeClass("active");
    $(this).closest("tbody").find("tr.penketh-saved-basket-row").hide();
    $(this).closest("tr.wsc_cart-tr-body").addClass("active");
    $(this).closest("tr").next(".penketh-saved-basket-row").show();
  });
});
